<template>
<div id="locale_switcher">
  <div :style="{width: width}">
    <v-select
      :items="locales"
      v-model="selected_locale"
      item-value="code"
      item-text="name"
      class="rounded_8px height_56px settings_textfield"
      outlined
      @change="switch_locale"
      background-color="#FFFFFF"
    />
  </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {i18n} from "@/i18n";
// import { getSupportedLocales } from "@/utils/supported-locales";
import {Trans} from "@/plugins/transition";

export default {
  name: "LocaleSwitcher",
  props: ['width', 'locales'],
  data: function () {
    return {
      selected_locale: i18n.locale,
      // locales: getSupportedLocales()
    }
  },
  methods: {
    switch_locale: function () {
      if (this.$i18n.locale !== this.selected_locale) {
        const to = this.$router.resolve({ params: {locale: this.selected_locale} })
        return Trans.changeLocale(this.selected_locale)
        .then(() => {
          this.$router.push(to.location)
          this.setSnackbar({
          text: i18n.t('notifications.system.language_changed'),
        })
        })

      }
    },
    ...mapActions(['setSnackbar']),
    ...mapGetters(['systemParams'])
  }
}
</script>

<style scoped>

#locale-card {
  background: #FFFFFF;
  box-shadow: 0 3px 2px rgba(138, 138, 138, 0.15);
  border-radius: 8px;
}
.locale_input {
  width: 170px;
  padding: 10px;
  border-radius: 4px;
}
.main_color {
  color: #207EA9;
}
</style>